// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"345a9c31","453":"76133f8c","455":"143017c3","977":"a27e7ee4"}[chunkId] + ".chunk.js";
};